import React, { FC } from 'react';
import styled from 'styled-components';
import { User } from 'api/models';
import { Avatar } from 'components/atoms/avatar';
import { NameCell } from 'components/organisms/timesheets/common/cells/name-cell';
import { fullName } from 'utils/full-name';

const Wrapper = styled.div`
  cursor: pointer;
`;

interface Props {
  user: User;
  projectId?: number;
  onUserSelection: (userId: number, projectId?: number) => void;
  isManagerApproval: boolean;
}
export const UserNameCell: FC<Props> = ({
  user,
  projectId,
  onUserSelection,
  isManagerApproval,
}) => {
  const userName = fullName(user);

  return (
    <Wrapper
      onClick={() => {
        if (isManagerApproval) {
          onUserSelection(user.userId);
        } else {
          onUserSelection(user.userId, projectId);
        }
      }}
    >
      <NameCell
        logo={<Avatar name={userName} src={user.photoUrl} />}
        primaryText={userName}
        secondaryText={user.role?.roleName}
      />
    </Wrapper>
  );
};
